import { IEvent } from '@interfaces/event';

export const getSDEvent = (events: IEvent[]) => {
  return events.find((event) => {
    const tags = event.eventTags || [];
    return (
      tags.includes('SD') &&
      tags.includes('FullTimeSDHub') &&
      !tags.includes('LINUX')
    );
  });
};
